import { render, staticRenderFns } from "./RosterAiIndex.vue?vue&type=template&id=3fe98466"
import script from "./RosterAiIndex.vue?vue&type=script&lang=js"
export * from "./RosterAiIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports